import { type PushChannel } from "./types";

export enum PushChannels {
  // Channel importance is immutable after creation, so to raise it (e.g. to get
  // heads-up notifications) we must use a NEW channel id. Bump the version
  // suffix whenever the channel's importance/behavior needs to change.
  // Previous id: "main-channel" (importance 3 / DEFAULT - no heads-up).
  Main = "main-channel-v1.0.0",
}

// Old channel ids that should be removed from the device. Their importance is
// immutable, so we migrate to a new id (see PushChannels.Main) and delete these.
// The JS layer deletes them too, so the cleanup ships via OTA (no store release).
export const LEGACY_PUSH_CHANNEL_IDS: string[] = ["main-channel"];

// App-wide policy: all channels use importance 4 (IMPORTANCE_HIGH) so
// notifications always pop on screen (heads-up) + sound. Keep new channels at 4.
export const PUSH_CHANNELS: PushChannel[] = [
  {
    id: PushChannels.Main,
    name: "WEME - MAIN",
    description:
      "This channel is used to pass information and opportunities to you",
    // 4 = IMPORTANCE_HIGH -> makes sound AND pops on screen (heads-up).
    importance: 4,
    lightColor: "#00b4d8",
    visibility: 1,
    sound: "default",
  },
];
